/** Categories whose replacement invalidates existing calibration */
export const CALIBRATION_SENSITIVE_CATEGORIES = new Set([
    'Full Smile', 'PreOp Maxilla', 'PreOp Mandible',
]);

export const PHOTO_CATEGORIES = [
    { label: 'Full Smile', value: 'Full Smile' },
    { label: 'Profile', value: 'Profile' },
    { label: '12 O\'Clock', value: '12 O\'Clock' },
    { label: 'Others', value: 'Others' },
];

export const MODEL_CATEGORIES = [
    { label: 'PreOp Maxilla', value: 'PreOp Maxilla' },
    { label: 'PreOp Mandible', value: 'PreOp Mandible' },
    { label: 'PostOp Maxilla', value: 'PostOp Maxilla' },
    { label: 'PostOp Mandible', value: 'PostOp Mandible' },
];

export const STEPS = [
    { key: 'digitalRecords', label: 'Digital Records', icon: '1' },
    { key: 'editFiles', label: 'Edit Files', icon: '2' },
    { key: 'calibrate', label: 'Digital Patient', icon: '3' },
];
